module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PlanView.js"));
	}, "PlanView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PlanView!./src/pages/Learn/Plan/PlanView.js
// module id = 2155
// module chunks = 367